export default "__VITE_ASSET__0c0e197a__"